export default function FulfillmentStatus({ status, className: classNameProp }: { status: string, className?: string }) {
  const { label, className } = getOrderStatusLabel(status);
  return (
    <span className={`${className} ${classNameProp} p-1 inline-block rounded-md`}>
      {label}
    </span>
  )
}

export const getOrderStatusLabel = (status: string) => {
  const statusMap: Record<string, { label: string; className: string }> = {
    pending_fullfillment: { label: 'Need Fullfillment', className: 'bg-red-100 text-yellow-800' },
    pending_shipment: { label: 'Need Shipment', className: 'bg-blue-100 text-blue-800' },
    shipping: { label: 'Shipping', className: 'bg-yellow-100 text-yellow-800' },
    shipping_problem: { label: 'Shipping Problem', className: 'bg-orange-100 text-orange-800' },
    shipping_pending_pickup: { label: 'Shipping Pending Pickup', className: 'bg-orange-100 text-orange-800' },
    shipping_outside_national: { label: 'Shipping (International)', className: 'bg-yellow-100 text-yellow-800' },
    shipping_national: { label: 'Shipping (National)', className: 'bg-yellow-100 text-yellow-800' },
    delivered: { label: 'Delivered', className: 'bg-green-100 text-green-800' },
  };
  
  const status_key = status.toLowerCase();
  return statusMap[status_key] || { label: status, className: 'bg-gray-100 text-gray-800' };
};

